import Filter from '@crehana/compass.icons.outline/Filter';
import {
  Dropdown,
  DropdownContent,
  DropdownEmpty,
  DropdownFilterButton,
  DropdownSearchInput,
  DropdownTextList,
} from '@crehana/compass.ui/dropdown';
import { clsx } from 'clsx';
import { PREVIEW_TABLE } from '../../../constants';
import { useTranslationCareerSiteAdminShared } from '../../../i18n/use-translations';
import type { TDepartmentFilterProps } from './types';

export const DepartmentFilter: React.FC<TDepartmentFilterProps> = ({
  departmentsData,
  previewType,
  onClear,
  onSelect,
}) => {
  const { t } = useTranslationCareerSiteAdminShared();

  if (!departmentsData.length) {
    return null;
  }

  return (
    <div
      className={clsx(
        'sm:tw-hidden tw-w-full tw-flex tw-justify-start',
        previewType === PREVIEW_TABLE.MOBILE && 'tw-hidden',
      )}
    >
      <Dropdown>
        <DropdownFilterButton
          disabled={false}
          multiselect={false}
          filterIcon={<Filter className="tw-text-inherit" size={16} />}
          onClear={onClear}
        >
          {t('FILTER_BY')}
        </DropdownFilterButton>
        <DropdownContent>
          <DropdownSearchInput placeholder={t('SEARCH_BY_DEPARTMENT')} />
          <DropdownEmpty
            title={t('NO_DEPARTMENTS_FOUND')}
            subtitle={t('TRY_ANOTHER_SEARCH')}
          />
          <DropdownTextList
            items={departmentsData.map(dept => ({
              value: dept.id,
              label: dept.name,
            }))}
            onSelect={onSelect}
            multiselect={false}
          />
        </DropdownContent>
      </Dropdown>
    </div>
  );
};
